import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { connect } from "react-redux";
import * as microsoftTeams from "@microsoft/teams-js";
import { getTaskDetails, setActiveAssignment } from "actions/assignments";
import { clearAssessments } from "actions/assessments";
import { clearBlocksOnReference } from 'actions/blocks';
import { Block, translate } from '@haldor/ui';
import { Spinner } from "UI";
import HaldorAssignment from "./Assignment/Haldor";
import MicrosoftAssignment from "./Assignment/Microsoft";

var SingleAssignmentV1 = /*#__PURE__*/function (_Component) {
  _inherits(SingleAssignmentV1, _Component);

  var _super = _createSuper(SingleAssignmentV1);

  function SingleAssignmentV1(props) {
    var _this;

    _classCallCheck(this, SingleAssignmentV1);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.setActiveAssignment();

      _this.props.clearAssessments();

      _this.props.clearBlocksOnReference();
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      var assignmentId = _this.props.match.params.assignmentId;

      if (_this.isIframe()) {
        microsoftTeams.app.getContext().then(function (context) {
          if (context.team) {
            _this.props.getTaskDetails(assignmentId, context.team.groupId).then(function () {
              _this.setState({
                loading: false
              });
            });
          } else {
            _this.props.getTaskDetails(assignmentId).then(function () {
              _this.setState({
                loading: false
              });
            });
          }
        });
      } else {
        _this.props.getTaskDetails(assignmentId).then(function () {
          _this.setState({
            loading: false
          });
        });
      }
    });

    _this.state = {
      loading: true
    };
    return _this;
  }

  _createClass(SingleAssignmentV1, [{
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var loading = this.state.loading;
      var assignment = this.props.assignment;

      if (loading || this.props.groups.length == 0) {
        return /*#__PURE__*/React.createElement("div", {
          key: "single-assignment-spinner"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      } // Check if assignment is null


      if (this.props.assignment == null) {
        return /*#__PURE__*/React.createElement("div", {
          className: "single-task"
        }, /*#__PURE__*/React.createElement("div", {
          className: "single-section left-side"
        }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("div", {
          style: {
            padding: '1rem 0'
          },
          className: "text--center color--meta weight--bold"
        }, this.props.translate('assignment-has-been-deleted')))), /*#__PURE__*/React.createElement("div", {
          className: "single-actions right-side"
        }));
      }

      if (assignment != null) {
        var _assignment$externalI;

        var assignmentId = (_assignment$externalI = assignment.externalID) !== null && _assignment$externalI !== void 0 ? _assignment$externalI : this.props.match.params.assignmentId;

        if (assignmentId == parseInt(assignmentId, 10) && assignment.origin !== "TEAMS") {
          return /*#__PURE__*/React.createElement(HaldorAssignment, {
            assignment: assignment
          });
        }

        return /*#__PURE__*/React.createElement(MicrosoftAssignment, {
          assignment: assignment
        });
      } else {
        return /*#__PURE__*/React.createElement("div", null, this.props.translate("assignment-not-found"));
      }
    }
  }]);

  return SingleAssignmentV1;
}(Component);

function mapStateToProps(state) {
  return {
    assignment: state.assignments.active_assignment,
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations),
    groups: state.sections.educationGroups,
    tenant: state.user.tenant
  };
}

export default connect(mapStateToProps, {
  getTaskDetails: getTaskDetails,
  clearAssessments: clearAssessments,
  setActiveAssignment: setActiveAssignment,
  clearBlocksOnReference: clearBlocksOnReference
})(SingleAssignmentV1);